import React, { useCallback, useEffect, useState } from 'react'
import PubSub from 'pubsub-js'
import classnames from 'classnames'
import SideNav from './index'
import Protal from 'Components/portal'
export default function ProtalModal({
  pageType = 'new',
}: {
  pageType?: string
}) {
  const isFixType = pageType?.indexOf('no-nav') > -1

  const [visible, setVisible] = useState(false)
  function openFixNav() {
    setVisible(true)
    document.body.style.overflow = 'hidden'
  }
  function closeFixNav() {
    setVisible(false)
    document.body.style.overflow = ''
  }

  const handler = useCallback(
    (type, value) => {
      if (value) {
        openFixNav()
        return
      }
      closeFixNav()
    },
    [setVisible]
  )

  useEffect(() => {
    const token = PubSub.subscribe('OPEN_FIX_NAV', handler)
    return () => {
      PubSub.unsubscribe(token)
    }
  }, [])

  return (
    <Protal getContainer={() => document.body}>
      <div
        className={classnames('fix-nav-modal-mask', {
          active: visible,
        })}
        onClick={e => {
          e.stopPropagation()
          PubSub.publish('OPEN_FIX_NAV', false)
        }}
      >
        <div className="fix-nav-header" onClick={e => e.stopPropagation()}>
          <p
            className={`side-nav-switch tw-mr-24 lg:tw-mr-40 fl`}
            onClick={e => {
              e.stopPropagation()
              PubSub.publish('OPEN_FIX_NAV', false)
            }}
          >
            <span className={`arrow ${isFixType ? 'top' : ''}`} />
          </p>
        </div>
        <SideNav fixType="on" />
      </div>
      <style jsx>
        {`
          .fix-nav-modal-mask {
            position: fixed;
            width: 100%;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            background-color: rgb(31 33 41 / 0.6);
            z-index: 99999 !important;
            display: none;
            padding-left: calc((100% - 1920px) / 2);
          }
          :global(.fix-nav-modal-mask .car-modal-mask) {
            background: #6f717a;
          }
          .fix-nav-modal-mask.active {
            display: block;
          }
          .fix-nav-header {
            width: 160px;
            height: 84px;
            background: #fff;
          }
          .side-nav-switch {
            position: relative;
            margin-left: 28px;
            width: 24px;
            height: 24px;
            margin-top: 30px;
            background: red;
            cursor: pointer;
            background: url(${require('static/icon-switch-btn.png')}) no-repeat
              0 0 / cover;
          }
          .arrow {
            width: 0;
            height: 0;
            position: absolute;
            right: 2px;
            bottom: 3px;
            border-right: 3px solid transparent;
            border-left: 3px solid transparent;
            border-bottom: 4px solid #1f2129;
            transform: rotate(270deg);
            transition: transform 0.2s ease-in-out;
          }
          .arrow {
            transform: rotate(270deg) !important;
          }
          .right.arrow {
            transform: rotate(90deg) !important;
          }
          .bottom.arrow {
            transform: rotate(180deg) !important;
          }
          .left.arrow {
            transform: rotate(270deg) !important;
          }
          .top.arrow {
            transform: rotate(0) !important;
          }
        `}
      </style>
    </Protal>
  )
}
